"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseKontentError = /** @class */ (function () {
    function BaseKontentError(data) {
        Object.assign(this, data);
    }
    return BaseKontentError;
}());
exports.BaseKontentError = BaseKontentError;
//# sourceMappingURL=base-kontent-error.js.map